import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

// Use relative /api path when served from a custom domain
// This avoids CORS issues when the frontend domain differs from REACT_APP_BACKEND_URL
function getApiBase() {
  if (!BACKEND_URL) return '/api';
  try {
    const configuredOrigin = new URL(BACKEND_URL).origin;
    const currentOrigin = window.location.origin;
    // If origins match, use configured URL; otherwise use relative path
    if (configuredOrigin === currentOrigin) return `${BACKEND_URL}/api`;
  } catch (e) {
    console.warn('Failed to parse REACT_APP_BACKEND_URL, falling back to relative /api path:', e);
  }
  // For custom domains (e.g. golfshop.fit), the backend is on the same origin
  // so we use relative /api path to avoid cross-origin requests
  return '/api';
}

export const API = getApiBase();

// Store for current tenant slug - set by TenantContext
let currentTenantSlug = null;

export function setTenantSlug(slug) {
  currentTenantSlug = slug;
}

export function getTenantSlug() {
  return currentTenantSlug;
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 45000, // Fail fast (45s) instead of spinning forever on hung backends
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add tenant header to all requests
api.interceptors.request.use((config) => {
  if (currentTenantSlug) {
    config.headers['X-Tenant-Slug'] = currentTenantSlug;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
